import C5RetiradaItemModel from "./C5RetiradaItemModel";

export default class C5DataRetiradaModel {
  public lojaId: string = "";
  public dataEntrega: Date = new Date();
  public itens: C5RetiradaItemModel[] = [];

  public static toModel(item: any): C5DataRetiradaModel {
    const horarios: C5RetiradaItemModel[] = [];
    for(let horario of item.Hours) {
      horarios.push(C5RetiradaItemModel.toModel(horario));
    }

    const entrega: Date = new Date(item.DeliveryDate);
    if(entrega.getHours() > 18) {
      entrega.setDate(entrega.getDate() + 1);
    }

    return {
      lojaId: item.StoreID,
      dataEntrega: entrega,
      itens: horarios
    } as C5DataRetiradaModel;
  }
}